import React from 'react';
import Button from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';

const NotificationFilters = ({
  activeFilter,
  onFilterChange,
  notificationCounts,
}) => {
  const filters = [
    { id: 'all', label: 'Todas', count: notificationCounts?.all },
    { id: 'unread', label: 'Não lidas', count: notificationCounts?.unread },
  ];

  return (
    <div
      className="inline-flex flex-wrap items-center gap-1 rounded-xl border border-border bg-muted/50 p-1"
      role="tablist"
      aria-label="Filtrar notificações"
    >
      {filters.map((filter) => {
        const isActive = activeFilter === filter.id;
        return (
          <Button
            key={filter.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            variant="ghost"
            size="sm"
            onClick={() => onFilterChange(filter.id)}
            className={cn(
              'h-9 rounded-lg px-3 font-medium transition-all',
              isActive
                ? 'bg-card text-foreground shadow-soft-sm hover:bg-card'
                : 'text-muted-foreground hover:text-foreground hover:bg-transparent'
            )}
          >
            {filter.label}
            {filter.count > 0 && (
              <span
                className={cn(
                  'ml-2 min-w-[1.25rem] px-1.5 py-0.5 text-xs font-semibold rounded-full tabular-nums',
                  isActive
                    ? 'bg-primary/15 text-primary'
                    : 'bg-muted text-muted-foreground'
                )}
              >
                {filter.count}
              </span>
            )}
          </Button>
        );
      })}
    </div>
  );
};

export default NotificationFilters;
